/**
 * Route paths for the staff-only Settings area. Shared by routes.js, the
 * left navigation and the Settings shell so the three never drift apart.
 */
export const SETTINGS_ROOT_PATH = '/settings';
export const SETTINGS_VIDEOS_PATH = '/settings/videos';

/**
 * The page /settings lands on. Settings has a single child today, so it
 * goes straight to Videos.
 */
export const SETTINGS_DEFAULT_PATH = SETTINGS_VIDEOS_PATH;
